<script setup lang="ts">
import { Link } from '~/lib/services/content/content.shared.dtos'

const props = defineProps<{ link: Link }>()

const pageLink = computed(() => props.link.page)
const urlLink = computed(() => props.link.url)
</script>

<template>
  <NuxtLink v-if="pageLink" :to="pageLink.path" :target="link.blank ? '_blank' : '_self'">
    <slot></slot>
  </NuxtLink>
  <NuxtLink
    v-else-if="urlLink"
    :to="urlLink"
    rel="nofollow noopener noreferrer"
    :target="link.blank ? '_blank' : '_self'"
    external
  >
    <slot></slot>
  </NuxtLink>
  <!-- TODO - handle action on link! -->
</template>
